<template>
  <default-layout show-leaderboard-ad>
    <div class="community-hub">
      <community-header />
      <div class="community-hub__section community-hub__section--activity">
        <div class="community-hub__column community-hub__column--50">
          <trending-topics />
        </div>
        <div class="community-hub__column community-hub__column--50">
          <latest-updates />
        </div>
      </div>
      <div
        class="community-hub__section community-hub__section--cta"
        data-test-id="community-hub-cta-section"
      >
        <forums-cta />
        <stories-cta />
        <private-message-cta />
      </div>
      <community-join-banner v-if="!userIsLoggedIn" />
      <div class="community-hub__section community-hub__section--people">
        <community-recommendations />
      </div>
      <p
        class="community-hub__rules"
        data-test-id="community-hub-rules"
      >
        Please keep our
        <a href="https://health-union.com/community-rules/"
           target="_blank"
           rel="noopener noreferrer nofollow"
        >
          community rules</a>
        in mind when posting. Questions or concerns? Email us at
        <a :href="`mailto:contact@${$site.name}`">contact@{{ $site.name.toLowerCase() }}</a>.
      </p>
    </div>
  </default-layout>
</template>

<script>
import CommunityHeader from '@/components/Community/CommunityHeader.vue';
import ForumsCta from '@/components/Community/ForumsCta.vue';
import StoriesCta from '@/components/Community/StoriesCta.vue';
import PrivateMessageCta from '@/components/Community/PrivateMessageCta.vue';
import CommunityJoinBanner from '@/components/Community/CommunityJoinBanner.vue';
import CommunityRecommendations from '@/components/Community/CommunityRecommendations.vue';
import TrendingTopics from '@/components/Community/TrendingTopics.vue';
import LatestUpdates from '@/components/Community/LatestUpdates.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'CommunityHub',
  components: {
    CommunityHeader,
    ForumsCta,
    StoriesCta,
    PrivateMessageCta,
    CommunityJoinBanner,
    CommunityRecommendations,
    TrendingTopics,
    LatestUpdates,
  },
  computed: {
    ...mapGetters(['userIsLoggedIn']),
    metaDescription() {
      const communityHub = this.$site.settings.community_hub || {};
      return communityHub.meta_description || '';
    },
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    onLoad() {
      const dataLayer = JSON.stringify({
        post_categories: ['community'],
        has_user_generated_content: true,
      });
      this.$emit('loaded', dataLayer);
    },
  },
  metaInfo() {
    if (!this.$store.getters.siteHasFeature('Accounts')) {
      return {
        meta: [
          {
            name: 'robots',
            vmid: 'robots',
            content: 'noindex',
          },
        ],
        link: [
          { vmid: 'canonical', content: null },
        ],
      };
    }
    return {
      title: 'Community Page',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.metaDescription,
        },
        {
          vmid: 'og:description',
          property: 'og:description',
          content: this.metaDescription,
        },
        {
          vmid: 'og:image',
          property: 'og:image',
          content: `https://${this.$root.hostname}/common/nexus/community-header.png`,
        },
        {
          vmid: 'twitter:description',
          property: 'twitter:description',
          content: this.metaDescription,
        },
        {
          vmid: 'twitter:image',
          name: 'twitter:image',
          content: `https://${this.$root.hostname}/common/nexus/community-header.png`,
        },
      ],
    };
  },
};
</script>

<style lang="scss"> // no scoped - to share classes with child components
  @import '@/stylesheets/components/_community-hub';
</style>
